import { CustomViewCtrls } from '@agilelab/plugin-wb-platform';
import { componentDetailsCtrl } from '../utils';

CustomViewCtrls.register({
  id: 'marketplace_data_contract_drawer',
  function: componentDetailsCtrl,
});
